import {rrulestr} from 'rrule';
import {format} from 'date-fns';
import {RRuleHelper} from '../../utils/RRuleHelper';
import {toIri} from '../../utils/apiResource';

export function getDefaultCampaignFormValues() {
    const currentDate = new Date();
    const tomorrowDate = new Date();
    tomorrowDate.setDate(currentDate.getDate() + 1);

    return {
        id: null,
        libelle: '',
        dateDebut: format(currentDate, 'yyyy-MM-dd'),
        dateFin: format(tomorrowDate, 'yyyy-MM-dd'),
        // Heure de début affichée sur le mobile ('HH:MM', facultative, sans timezone)
        heureDebut: '',
        freq: RRuleHelper.FREQ[1].id,
        interval: 1,
        byDay: [],
        byMonthDay: [],
        byMonth: '',
        bySetPos: RRuleHelper.SETPOS[0].id,
        recurrenceType: RRuleHelper.RECURRINGTYPE.DAYOFMONTH,
        conteneurs: [],
        chauffeur: '',
        equipier: '',
        prestation: '',
        client: '',
        formulaire: '',
        patrimoine: '',
        ordre: [],
    };
}

export function mapCampaignApiToForm(campaign, fallbackValues = {}) {
    const defaults = getDefaultCampaignFormValues();
    const source = campaign ?? {};
    const parsedRRule = source.rrule ? rrulestr(source.rrule) : null;

    return {
        ...defaults,
        ...fallbackValues,
        id: source.id ?? fallbackValues.id ?? defaults.id,
        libelle: source.libelle ?? fallbackValues.libelle ?? defaults.libelle,
        dateDebut: source.dateDebut ?? fallbackValues.dateDebut ?? defaults.dateDebut,
        dateFin: source.dateFin ?? fallbackValues.dateFin ?? defaults.dateFin,
        heureDebut: source.heureDebut ?? fallbackValues.heureDebut ?? defaults.heureDebut,
        freq: parsedRRule ? RRuleHelper.FREQMAP[parsedRRule.options.freq] : (fallbackValues.freq ?? defaults.freq),
        interval: parsedRRule ? parsedRRule.options.interval : (fallbackValues.interval ?? defaults.interval),
        byDay: parsedRRule && parsedRRule.options.byweekday
            ? parsedRRule.options.byweekday.map(d => RRuleHelper.DAYMAP[d])
            : (fallbackValues.byDay ?? defaults.byDay),
        byMonthDay: parsedRRule ? parsedRRule.options.bymonthday : (fallbackValues.byMonthDay ?? defaults.byMonthDay),
        byMonth: parsedRRule ? RRuleHelper.MONTHMAP[parsedRRule.options.bymonth] : (fallbackValues.byMonth ?? defaults.byMonth),
        bySetPos: parsedRRule ? parsedRRule.options.bysetpos : (fallbackValues.bySetPos ?? defaults.bySetPos),
        recurrenceType: source.recurrenceType ?? fallbackValues.recurrenceType ?? defaults.recurrenceType,
        conteneurs: source.conteneurs
            ? source.conteneurs.map((c) => toIri('conteneurs', c)).filter(Boolean)
            : (fallbackValues.conteneurs ?? defaults.conteneurs),
        chauffeur: toIri('users', source.chauffeur) || fallbackValues.chauffeur || defaults.chauffeur,
        equipier: toIri('users', source.equipier) || fallbackValues.equipier || defaults.equipier,
        prestation: toIri('prestations', source.prestation) || fallbackValues.prestation || defaults.prestation,
        client: toIri('clients', source.client) || fallbackValues.client || defaults.client,
        formulaire: toIri('formulaires', source.formulaire) || fallbackValues.formulaire || defaults.formulaire,
        patrimoine: toIri('patrimoines', source.patrimoine) || fallbackValues.patrimoine || defaults.patrimoine,
        ordre: source.ordre ?? fallbackValues.ordre ?? defaults.ordre,
    };
}

export function mapCampaignFormToPayload(values) {
    return {
        ...values,
        client: toIri('clients', values.client),
        prestation: toIri('prestations', values.prestation),
        formulaire: toIri('formulaires', values.formulaire),
        patrimoine: toIri('patrimoines', values.patrimoine),
        conteneurs: (values.conteneurs ?? []).map((c) => toIri('conteneurs', c)).filter(Boolean),
        chauffeur: toIri('users', values.chauffeur),
        equipier: values.equipier ? toIri('users', values.equipier) : null,
        rrule: RRuleHelper.buildRRuleString(values),
        // '' (champ vidé) → null : l'API attend HH:MM ou null, jamais une chaîne vide
        heureDebut: values.heureDebut || null,
        // Compatibilité mobile/API : `ordre` reste dans le format existant.
        ordre: values.ordre ?? [],
    };
}